$(function () {
  var $megamenu = $('.megamenu');

  window.pushDataLayer = function (action, url, callback) {
    if (dataLayer) {
      dataLayer.push({
        "event": "navigation",
        "action": action,
        "click_url": url
      });
    }
    if (typeof callback === 'function') {
      callback();
    }
  }

  $megamenu.find('.megamenu__dropdown-toggle').click(function (e) {
    var $this = $(this);
    if ($this.hasClass('js-scroll-to-form')) {
      var form = document.getElementsByClassName("iframe-form-block")[0];
      if (typeof form != 'undefined') {
        form.scrollIntoView({ block: "start", behavior: "smooth", });
        var formHeading = form.querySelector('.form-heading');
        if (typeof formHeading != 'undefined') {
          formHeading.click();
        }
      }
      $megamenu.removeClass('open');
      return;
    }
    var $buttonParent = $this.parent(),
      $menuBg = $buttonParent.find('.subnavigation__background-container'),
      activeItemPos,
      lastSubmenuItemPos,
      firstSubmenuItemPos;
    // Close sub navigation
    if ($buttonParent.hasClass('open')) {
      closeMegamenu();
    }
    // Open sub navigation
    else {
      openMegamenu(e);
    }

    function openMegamenu(e) {
      e.stopImmediatePropagation() 
      $megamenu.find('.megamenu__dropdown-toggle').parent().removeClass('open');
      $buttonParent.find('>button').attr('aria-expanded', 'true');
      $buttonParent.addClass('open');
      setBgMinWidth();
      $(window).resize(setBgMinWidth);
      $(document).click(handleClickOutsideMegamenu);
      $(document).keyup(handleEscKeyPress);
    }

    function closeMegamenu() {
      $buttonParent.removeClass('open');
      $buttonParent.find('>button').attr('aria-expanded', 'false');
      $(window).off('resize', setBgMinWidth);
      $(document).off('click', handleClickOutsideMegamenu);
      $(document).off('keyup', handleEscKeyPress);
    }

    // Adjust menu width
    function setBgMinWidth() {
      var $subnavigation = $buttonParent.find('.subnavigation__list');
      if ($subnavigation.length) {
        if (window.innerWidth >= 1200 && $buttonParent.hasClass('open')) {
          if ($buttonParent.hasClass('megamenu__right-links--corporate') || $buttonParent.hasClass('right')) {
            let leftAlign = $buttonParent.offset().left;
            let width = 0;
            $subnavigation.find('>li').each(function () {
              width += $(this).outerWidth() + 35;
            });
            if (width + leftAlign <= document.body.clientWidth) {
              $menuBg.css({
                left: leftAlign + 35 + 'px'
              });
              $subnavigation.css({
                left: leftAlign + 35 + 'px',
                margin: 0
              });
            }
            else {
              $menuBg.css({
                right: $megamenu.offset().left - 35 + 'px',
                left: 'auto'
              });
              $subnavigation.css({
                left: document.body.clientWidth - $megamenu.offset().left - width + 35 + 'px',
                margin: 0
              });
            }
            
            $menuBg.css({
              minWidth: width + 35 + 'px'
            });
          }
          else {
            $menuBg.css({
              left: $subnavigation.offset().left + 'px'
            });
            var $lastMegamenuBlock = $subnavigation.find('>li:last-child');
            activeItemPos = $buttonParent.offset().left + $buttonParent.outerWidth();
            lastSubmenuItemPos = $lastMegamenuBlock.offset().left + $lastMegamenuBlock.outerWidth() + 35;
            $menuBg.css({
              minWidth: (activeItemPos > lastSubmenuItemPos ? activeItemPos : lastSubmenuItemPos) - $menuBg.offset().left + 'px'
            });
          }
        }
      }
      
    }

    function handleClickOutsideMegamenu(e) {
      if (window.innerWidth >= 1200) {
        var $bgContainer = $buttonParent.find('.subnavigation__background-container');
        if ($bgContainer.length) {
          var bgContainerOffset = $bgContainer.offset(),
            bgContainerWidth = $bgContainer.outerWidth(),
            bgContainerHeight = $bgContainer.outerHeight();
          // Click outside white bg container
          if (
            e.pageX < bgContainerOffset.left ||
            e.pageX > bgContainerOffset.left + bgContainerWidth ||
            e.pageY < bgContainerOffset.top ||
            e.pageY > bgContainerOffset.top + bgContainerHeight
          ) {
            $megamenu.find('.megamenu-block__search-results ul').empty();
            closeMegamenu();
          }
        }
        else {
          closeMegamenu();
        }
      }
    }

    function handleEscKeyPress(e) {
      if (window.innerWidth >= 1200) {
        // Escape press
        if (e.which === 27) {
          var $target = $(e.target);
          // Escape in finder block to hide dropdown
          if ($target.is('.megamenu-block--finder-block input') || $target.is('.megamenu-block__search-results a')) {
            $target.parents('.megamenu-block--finder-block').find('ul').empty();
          }
          // Hide megamenu on escape press
          else {
            $megamenu.find('button[aria-expanded=true]').focus();
            closeMegamenu();
          }
        }
      }
    }
  });

  $megamenu.find('.language-button').click(function (e) {
    var $this = $(this);
    if ($this.parent().hasClass('open')) {
      closeLanguageMenu();
    }
    else {
      $this.parent().siblings().find('.subnavigation').removeClass('open');
      openLanguageMenu();
    }

    function handleClickOutsideLangMenu(e) {
      var $langMenu = $megamenu.find('.language-button + .subnavigation');
      if (
        $langMenu && (
          e.pageX < $langMenu.offset().left ||
          e.pageX > $langMenu.offset().left + $langMenu.outerWidth() ||
          e.pageY < $langMenu.offset().top ||
          e.pageY > $langMenu.offset().top + $langMenu.outerHeight()
        )
      ) {
        closeLanguageMenu();
      }
    }

    function handleLangMenuCloseOnEscape(e) {
      if (e.which === 27) {
        var $target = $(e.target);
        if ($target.is('.language-button + .subnavigation') || $target.is('.language-button + .subnavigation a')) {
          closeLanguageMenu();
        }
      }
    }
    function openLanguageMenu() {
      $this.parent().addClass('open');
      $this.attr('aria-expanded', 'true');
      $(document).keyup(handleLangMenuCloseOnEscape);
      setTimeout(() => {
        $(document).on('click', handleClickOutsideLangMenu);
      });
    }
    function closeLanguageMenu() {
      $megamenu.find('.language-button').attr('aria-expanded', 'false').focus().parent().removeClass('open');
      $(document).off('keyup', handleLangMenuCloseOnEscape);
      $(document).off('click', handleClickOutsideLangMenu);
    }
  });

  $megamenu.find('.megamenu-block--finder-block').each(function () {
    var $this = $(this),
      $searchResultsListElm = $this.find('.megamenu-block__search-results ul'),
      arrowIconSvg = $searchResultsListElm.find('.initial-item').html(),
      options = JSON.parse($this[0].dataset.options);
    $this.find('input').on('input click', function (e) {
      if (window.innerWidth >= 722) {
        closeAllMegamenuFinderBlockDropdowns();
        if (e.target.value.length > 1) {
          var results = options.filter(obj => {
            return obj.Title.toLowerCase().includes(e.target.value.toLowerCase())
          });
          if (results.length) {
            results.slice(0, 4).forEach(function (item) {
              $searchResultsListElm.append('<li><a href="' + item.Url + '" title="' + item.Title + '">' + item.Title + arrowIconSvg + '</a></li>');
            });
          }
        }
      }
    });
  });

  $megamenu.find('.megamenu__hamburger button').click(function () {
    if (window.innerWidth < 1200) {
      if ($megamenu.hasClass('open')) {
        $megamenu.removeClass('open');
      }
      else {
        $megamenu.find('.megamenu__right-links .subnavigation.open').removeClass('open');
        $megamenu.addClass('open');
      }
    }
  });

  $megamenu.click(function (e) {
    if (!$(e.target).is('.megamenu-block--finder-block input') && !$(e.target).is('.megamenu-block__search-results')) {
      closeAllMegamenuFinderBlockDropdowns();
    }
  });

  $megamenu.find('>ul >li:visible button[aria-haspopup], >ul >li:visible >a, .megamenu__search--label').parent().on('keydown', function (e) {
    var key = e.originalEvent.keyCode;
    var $target = $(e.target);
    if (key === 32) { // Space
      // avoid prevent default if space is pressed on input
      if ($target.is('input')) {
        return;
      }
      e.preventDefault();
      $target.click();
    }
    else if (key === 27) { // Escape
      if ($target.is('.megamenu__dropdown-toggle') || $target.is('.megamenu__right-links button')) {
        $target.focus();
        $target.click();
      }
    }
    // key down or up to navigate through the dropdown items
    else if (key === 38 || key === 40) { // Up or Down
      e.preventDefault();
      var $dropdown = $(this).find('.subnavigation');
      if ($dropdown.length) {
        if ($(this).hasClass('open')) {
          var $items = $dropdown.find('a');
          if ($items.length) {

            var currentIndex = $items.index(document.activeElement);
            if (key === 40) { // Down
              currentIndex = (currentIndex + 1) % $items.length;
            }
            else { // Up
              currentIndex = (currentIndex - 1 + $items.length) % $items.length;
            }
            $items.eq(currentIndex).focus();
          }
        }
        else if (key === 40) { // Down
          $target.click();
        }
      }
    }
    // arrow left or right to navigate through the megamenu blocks
    else if (key === 37 || key === 39) { // Left or Right
      e.preventDefault();
      var $blocks = $megamenu.find('>ul >li:visible button[aria-haspopup], >ul >li:visible >a, .megamenu__search--label');
      if ($blocks.length) {
        var currentIndex = $blocks.index(document.activeElement);
        if (key === 39) { // Right
          currentIndex = (currentIndex + 1) % $blocks.length;
        }
        else { // Left
          currentIndex = (currentIndex - 1 + $blocks.length) % $blocks.length;
        }
        $blocks.eq(currentIndex).focus();
      }
    }
  });

  function closeAllMegamenuFinderBlockDropdowns() {
    $megamenu.find('.megamenu-block__search-results ul').empty()
  }

  // Fix for iOS mobile - update --vh variable on every viewport size change, it is used in scss
  window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  });

  // Search
  $megamenu.find('.megamenu__search form').on('submit', function (e) {
    if ($megamenu.find('.megamenu__search input').val() === '') {
      e.preventDefault();
    }
  })


  var navigationHeight = 69;
  $(window).scroll(function (e) {
    if (window.innerWidth >= 1200) {
      if (e.target.scrollingElement.scrollTop > navigationHeight) {
        if (!$megamenu.hasClass('scrolling')) {
          $megamenu.addClass('scrolling');
        }
      }
      else {
        if ($megamenu.hasClass('scrolling')) {
          $megamenu.removeClass('scrolling');
        }
      }
    }
  });

  if (window.location.hash) {
    var $scrollTarget = $(window.location.hash);
    if ($scrollTarget.length) {
      $('html, body').animate({
        scrollTop: ($scrollTarget.offset().top - 2 * navigationHeight)
      }, 1000);
    }
  }
  

  // Accessibility shortcut link 
  $('#skip-to-main-content-link')
    .click(function (e) {
      e.preventDefault();
      var $target = $(this.hash);
      if ($target.length) {
        $target.focus();
      }
    });

  const $menuSearchInput = $megamenu.find('#global-search-input');
  $menuSearchInput.on('input', () => {
    if ($menuSearchInput.val() === '') {
      $menuSearchInput.siblings('button[type=submit]').attr('disabled', true);
    }
    else {
      $menuSearchInput.siblings('button[type=submit]').attr('disabled', null);
    }
  });
});